import { useMutation } from "react-query";
import getSKU from "../services/getSKU";
function useGetSku() {
  return useMutation(["GETSKU"], getSKU);
}

export default useGetSku;
